<template>
  <section>
    <div class="banner half-vh">
      <img class="banner-image" src="./../assets/images/large/photo-about.jpg" alt=""
        v-bind:srcset="photos.xs + ' 320w, ' + photos.s + ' 768w, ' + photos.m + ' 1440w, ' + photos.l + ' 1920w'"
      >
    </div>
    <div class="container" id="about-us">
      <div class="text-content-wrapper">
        <h1>About Jwayelani</h1>

        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-3 col-sm-2">
                <div class="icon-wrapper">
                  <icon class="icon" name="shopping-basket"></icon>
                </div>
              </div>
              <div class="column text col-9 col-sm-10">
                <h2>Supermarket</h2>
                <p>Our supermarkets are built for your convenience and offer easy access to all our goods. Suitable for bulk or every day shopping, our products are competitively priced to cater to all your shopping needs, and our helpful staff provide friendly, caring, and efficient service creating a satisfying shopping experience just for you.</p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-3 col-sm-2">
                <div class="icon-wrapper">
                  <img class="icon" src="./../assets/svg/meat-white.svg" />
                </div>
              </div>
              <div class="column text col-9 col-sm-10">
                <h2>Butchery</h2>
                <p>All Jwayelani butcheries are supplied by our progressive Meat Plant. We supply meat of the finest grade – all carefully prepared, packaged, and labelled for your convenience. Our extensive range of quality meats provide you with great choice at great prices, and is the basis of our customers loyalty and trust.</p>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-3 col-sm-2">
                <div class="icon-wrapper">
                  <icon class="icon" name="industry"></icon>
                </div>
              </div>
              <div class="column text col-9 col-sm-10">
                <h2>Meat Plant</h2>
                <p>All Jwayelani butcheries and supermarkets are supplied by this state-of-the-art, professionally run meat plant. Our Meat Plant ensures the highest standards of manufacturing processes, providing a wide range of quality meat products. Our expertly trained staff constantly strive towards a safe and hazard-free food preparation environment so that you get only the best when shopping at Jwayelani.</p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-3 col-sm-2">
                <div class="icon-wrapper">
                  <icon class="icon" name="cubes"></icon>
                </div>
              </div>
              <div class="column text col-9 col-sm-10">
                <h2>Distribution Centre</h2>
                <p>The Jwayelani Distribution Centre is used for the storage and re-distribution of dry goods. All Jwayelani supermarkets are supplied by this centre, which is dedicated to providing excellent service through the efficient delivery of products, creating a better stocked store that can cater to all your shopping needs.</p>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-3 col-sm-2">
                <div class="icon-wrapper">
                  <icon class="icon" name="video-camera"></icon>
                </div>
              </div>
              <div class="column text col-9 col-sm-10">
                <h2>Corporate Video</h2>
                <p>For more information take a look at our corporate video below.</p>
                <video src="./../assets/video/corporate.mp4" controls></video>
              </div>
            </div>
          </div>
        </div> -->
      </div>

    </div>
  </section>
</template>

<script>

var photos = {
  xs: require('./../assets/images/x-small/photo-about_xs.jpg'),
  s: require('./../assets/images/small/photo-about_s.jpg'),
  m: require('./../assets/images/medium/photo-about_m.jpg'),
  l: require('./../assets/images/large/photo-about.jpg')
}

export default {
  name: 'about-us',
  data () {
    return {}
  },
  computed: {
    photos () { return photos }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '../scss/colours.scss';
  @import '../scss/mixins.scss';

  .banner{
    margin-bottom: 0;
  }

  .container{
    padding-top: 2em;
  }

  .icon-wrapper{
    position: relative;
    width: 100%;
    padding-bottom: 100%;
    background-color: $blue;
    border-radius: 50%;

    .icon{
      color: white;
      fill: white;
      stroke: white;
    }

    .fa-icon, .icon{
      position: absolute;
      width: auto;
      height: 50%;
      top:50%;
      left:50%;
      transform: translate(-50%, -50%);
    }
  }

  .row{
    margin-top: 1em;
  }

  .column{
    margin-bottom: 1em;

    &.text{
      padding-bottom: 1em;
    }

    img, video{
      width: 100%;
      height: auto;
    }
  }

  @include breakpoint(lg){
    .banner-image{
      margin-top: -5%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AboutUs.vue